import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react-lite';
import InvestmentActions from 'molecules/InvestmentActions';
import React, { forwardRef } from 'react';
import { isLimitedOffering } from 'stores/offeringUtils';
import { useStore } from 'stores/store';
import { useUserAuth } from 'utils/hooks/useUserAuth';

import s from './HeaderOffering.module.scss';

const HeaderOffering = forwardRef<HTMLDivElement>((props, ref) => {
  const store = useStore();
  const authDetails = useUserAuth();

  const offeringTitle = store.ContentClientStore.getOfferingTitle;
  const offeringInfo = store.ContentClientStore.getOfferingInfo;
  const offeringData = store.ContentClientStore.getAllContentData?.offering;

  const limitedOffering = isLimitedOffering(offeringInfo);

  return (
    <div ref={ref} {...props} className={s.HeaderOffering}>
      <div className={s.HeaderOffering__info}>
        <Typography variant="h1" mr={3} className={s.HeaderOffering__title}>
          <Box component="span" sx={{ color: 'primary.main', mr: 0.75 }}>
            {offeringTitle.offeringId}
          </Box>
          {offeringTitle.name}
        </Typography>
        <Typography variant="body2" className={s.HeaderOffering__subtitle}>
          {offeringTitle.type} | {offeringTitle.description}
        </Typography>
      </div>
      <InvestmentActions
        className={s.HeaderOffering__action}
        enableActions={authDetails.isApproved && !authDetails.isManagement}
        isAuthenticated={authDetails.isAuthenticated}
        isApproved={authDetails.isApproved}
        isManagement={authDetails.isManagement}
        isLimitedOffering={limitedOffering}
      />
    </div>
  );
});

export default observer(HeaderOffering);
